var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "title-container" }, [
      _vm._v(_vm._s(_setup.text.title)),
    ]),
    _c("div", { staticClass: "text-container" }, [
      _c("div", { staticClass: "info-container" }, [
        _c("span", { class: [_setup.icon.email, "lf-icon__xl"] }),
        _c("a", { staticClass: "email", attrs: { href: _setup.emaiURL } }, [
          _vm._v(_vm._s(_setup.text.email)),
        ]),
      ]),
      _c("div", { staticClass: "info-container" }, [
        _c("span", { class: [_setup.icon.phone, "lf-icon__xl"] }),
        _c("div", { staticClass: "phone-container" }, [
          _c("span", { staticClass: "phone" }, [
            _vm._v(_vm._s(_setup.text.phones)),
          ]),
          _c("span", { staticClass: "timetable" }, [
            _vm._v(_vm._s(_setup.text.timetable)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }